import store from "../store";
const localeJson = require("../../lang/locale.json");
export function inputNameLocale(value, param, key) {
  if (!value) return;
  if (!key) key = param;
  var locale = store.getters.selectedLocale;
  try {
    return value.replace(param, localeJson[locale]["message"][key]);
  } catch {
    return value;
  }
}
